import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from '../../../shared/modal/content';
import PopupHeader from '../../popupHeader';
import CenterPanel from './centerPanel';
import { saveWaitingAreaInfoForCallers } from '../../../../actions/waitingArea.js';
import RightPanel from './rightPanel';

export default function SupportContactModalContent(props) {
  const dispatch = useDispatch();
  const [saveInfoDispatchObj, setSaveInfoDispatchObj] = useState({});

  const saveInformationForCallers = (cb) => {
    let informationForCallersForm = {
      pdf64: saveInfoDispatchObj.pdf64,
      moreAssistance: props.informationForCallersForm.moreAssistance,
      isRemoved: saveInfoDispatchObj.isRemoved,
      fileName: saveInfoDispatchObj.fileName,
      includeCallerLink: props.informationForCallersForm.includeCallerLink,
    };
    dispatch(saveWaitingAreaInfoForCallers(props.waitingArea.id, informationForCallersForm, cb));
  };

  let centerPanel = '';
  centerPanel = (
    <CenterPanel
      setSaveInfoDispatchObj={setSaveInfoDispatchObj}
      informationForCallersForm={props.informationForCallersForm}
      waitingArea={props.waitingArea}
      updateOrView={props.updateOrView}
    />
  );

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        title={APP.LANGUAGE.InformationForCallersModal.Title}
        subtitle={(props.waitingArea ? props.waitingArea.name : '') + ' (' + props.waitingArea.organisationName + ')'}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpInfoForCallers}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-during-calls">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <RightPanel
                saveInformationForCallers={saveInformationForCallers}
                updateOrView={props.updateOrView}
                waitingAreaId={props.waitingArea.id}
                informationForCallersForm={props.informationForCallersForm}
              />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel
                saveInformationForCallers={saveInformationForCallers}
                updateOrView={props.updateOrView}
                waitingAreaId={props.waitingArea.id}
                informationForCallersForm={props.informationForCallersForm}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
